import { DeepDive } from '@backrs_ui/common-ui';

import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../baseQuery';

export type PaginatedDeepDivesParams = Readonly<{
  range: readonly [number, number];
  shuffleSeed: number;
}>;

export type PaginatedDeepDivesResult = Readonly<{
  data: readonly DeepDive[];
  total: number;
}>;

export const deepDiveApi = createApi({
  reducerPath: 'deepDiveApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getDeepDives: builder.query<DeepDive[], undefined>({
      query: () => 'deep-dives/browse',
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getDeepDivesPaginated: builder.query<PaginatedDeepDivesResult, PaginatedDeepDivesParams>({
      queryFn: async ({ range, shuffleSeed }, _queryApi, _extraOptions, baseQuery) => {
        const params = new URLSearchParams();

        params.append('range', JSON.stringify(range));
        params.append('shuffle', String(shuffleSeed));

        const result = await baseQuery(`deep-dives/browse?${params.toString()}`);

        if (result.error) {
          return { error: result.error };
        }

        const total = parseInt(
          (result.meta as { response?: Response })?.response?.headers.get('X-Total-Count') ?? '0',
          10,
        );

        return { data: { data: result.data as DeepDive[], total } };
      },
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getDeepDiveById: builder.query<DeepDive, number>({
      query: (id) => `deep-dives/browse/${id}`,
      keepUnusedDataFor: 60 * 60 * 24,
    }),
  }),
});

export const { useGetDeepDivesQuery, useGetDeepDivesPaginatedQuery, useGetDeepDiveByIdQuery } =
  deepDiveApi;
